import * as React from "react";
import {
  Box,  
  Card,
  CardContent,
  Container,
  Divider,  
  Stack,
  Typography,
  Link as MuiLink,
} from "@mui/material";
import Grid from "@mui/material/GridLegacy";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import VerifiedIcon from "@mui/icons-material/Verified";
import LaunchIcon from "@mui/icons-material/Launch";

const ContactUs = () => {
  const address =
    "SNO 5/2/1 Daffodils, Gulmohar City, Kharadi, Viman Nagar, Pune 411014, Maharashtra, India";

  const mapsLink = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;

  return (
    <Box component="main">
      {/* HERO */}
      <Box
        sx={{
          py: { xs: 6, md: 8 },
          bgcolor: "background.paper",
          borderBottom: "1px solid",
          borderColor: "divider",
        }}
      >
        <Container maxWidth="lg">
          <Box sx={{ textAlign: "center", maxWidth: 900, mx: "auto" }}>
            <Typography variant="h4" component="h1" fontWeight={900} gutterBottom>
              Contact Us
            </Typography>
            <Typography variant="h6" color="text.secondary">
              Reach out for product inquiries, partnerships, or a quick discussion about your education platform.
            </Typography>
          </Box>
        </Container>
      </Box>

      {/* CONTACT DETAILS */}
      <Container maxWidth="lg" sx={{ py: { xs: 5, md: 7 } }}>
        <Grid container spacing={3}>
          {/* Left: Contact cards */}
          <Grid item xs={12} md={7}>
            <Stack spacing={3}>
              <Card variant="outlined" sx={{ borderRadius: 3 }}>
                <CardContent>
                  <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 1 }}>
                    <PhoneIcon />
                    <Typography variant="h6" fontWeight={900}>
                      Phone
                    </Typography>
                  </Stack>
                  <Typography color="text.secondary" sx={{ mb: 1 }}>
                    Call or Text SMS
                  </Typography>
                  <MuiLink href="tel:+919096232337" underline="hover" variant="body1">
                    +91 9096232337
                  </MuiLink>
                </CardContent>
              </Card>

              <Card variant="outlined" sx={{ borderRadius: 3 }}>
                <CardContent>
                  <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 1 }}>
                    <EmailIcon />
                    <Typography variant="h6" fontWeight={900}>
                      Email
                    </Typography>
                  </Stack>
                  <Typography color="text.secondary" sx={{ mb: 1 }}>
                    Write to us
                  </Typography>
                  <MuiLink href="mailto:bis9.llp@gmail.com" underline="hover" variant="body1">
                    bis9.llp@gmail.com
                  </MuiLink>
                </CardContent>
              </Card>

              <Card variant="outlined" sx={{ borderRadius: 3 }}>
                <CardContent>
                  <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 1 }}>
                    <LocationOnIcon />
                    <Typography variant="h6" fontWeight={900}>
                      Registered Address
                    </Typography>
                  </Stack>
                  <Typography color="text.secondary" sx={{ mb: 1 }}>
                    {address}
                  </Typography>

                  <MuiLink
                    href={mapsLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    underline="hover"
                    sx={{ display: "inline-flex", alignItems: "center", gap: 0.75 }}
                  >
                    Open in Google Maps <LaunchIcon fontSize="small" />
                  </MuiLink>
                </CardContent>
              </Card>
            </Stack>
          </Grid>

          {/* Right: Compliance + CTA */}
          <Grid item xs={12} md={5}>
            <Card variant="outlined" sx={{ borderRadius: 3, height: "100%" }}>
              <CardContent>
                <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 1 }}>
                  <VerifiedIcon />
                  <Typography variant="h6" fontWeight={900}>
                    Company Information
                  </Typography>
                </Stack>

                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  Official identifiers for reference.
                </Typography>

                <Divider sx={{ mb: 2 }} />

                <Stack spacing={1.5}>
                  <Box>
                    <Typography variant="subtitle2" fontWeight={800}>
                      Registered Name
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      BhamuIntelli Systems LLP
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="subtitle2" fontWeight={800}>
                      LLPIN
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      ACR-5927
                    </Typography>
                  </Box>

                  <Box>
                    <Typography variant="subtitle2" fontWeight={800}>
                      PAN
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      ABFFB*****
                    </Typography>
                  </Box>

                  <Box>
                    <Typography variant="subtitle2" fontWeight={800}>
                      TAN
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      PNEB2*****
                    </Typography>
                  </Box>
                </Stack>

                
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default ContactUs;
